export enum SelectedProjectRole {
  Admin = 'Admin',
  Lead = 'Lead',
  Editor = 'Editor',
  Collaborator = 'Collaborator',
}
